<template>
  <div class="container">
    <div class="contact" @click="openPopup">
      <img src="../assets/img/lianxi.png" alt="" />
      联系我们
    </div>
    <div class="back" @click="goTop">
      <img src="../assets/img/hddb.png" alt="" />
    </div>
    <van-popup v-model="show" closeable>
      <div class="popup">
        <img :src="contact.image" />
        <div class="popup-conten">
          <div class="popup-conten-title">联系我们</div>
          <div class="popup-conten-conten">{{ contact.content }} </div>
          <div class="popup-conten-bottom">
            <img class="popup-conten-bottom-img" src="@/assets/img/lianxi1.png" alt="" />
            <div class="popup-conten-bottom-conten">{{ contact.phone1 }}</div>
          </div>
          <div class="popup-conten-bottom center">
            <img class="popup-conten-bottom-img" src="@/assets/img/dianhua.png" alt="" />
            <div class="popup-conten-bottom-conten">{{ contact.phone2 }}</div>
          </div>
          <div class="popup-conten-bottom">
            <img class="popup-conten-bottom-img" src="@/assets/img/youxiang.png" alt="" />
            <div class="popup-conten-bottom-conten">{{ contact.email }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>


import { $get_contact } from '@/api/index.js'

export default {
  name: "Contact",
  data () {
    return {
      contact: {},
      show: false,
    };
  },



  async mounted () {
    try {
      let res = await $get_contact();
      this.contact = res.data
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    openPopup () {
      if (this.windowWidth() > 767) {
        this.show = true;
      } else {
        window.location.href = "tel:15916368613";
      }
    },
    goTop () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 767px) {
  .container {
    position: fixed;
    right: 0;
    top: 56%;
    cursor: pointer;
    z-index: 99;
  }

  .contact {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    width: 40px;
    height: 110px;
    background: #ea4949;
    margin-bottom: 5px;
    color: #fff;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    padding: 0 12px;
  }

  .back {
    width: 40px;
    height: 40px;
    background: #ababab;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .popup {
    min-width: 740px;
    min-height: 310px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    img {
      width: 259px;
      height: 177px;
    }

    .popup-conten {
      margin-left: 38px;
      padding: 11px 0 25px 0;

      .center {
        margin: 10px 0;
      }

      .popup-conten-title {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-bottom: 31px;
      }

      .popup-conten-conten {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        margin-bottom: 27px;
      }

      .popup-conten-bottom {
        display: flex;
        align-items: center;


        .popup-conten-bottom-img {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }

        .popup-conten-bottom-conten {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          // margin-bottom: 27px;
        }
      }

    }

  }
}

@media (max-width: 767px) {
  .container {
    position: fixed;
    right: 0;
    top: 80%;
    z-index: 99;
  }

  .contact {
    width: 24px;
    height: 82px;
    background: #eb5b67;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    padding: 0 7px;
    margin-bottom: 3px;
    line-height: 16px;
  }

  .back {
    width: 24px;
    height: 24px;
    background: #ababab;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 12px;
      height: 6px;
    }
  }
}
</style>
